import React from 'react';
import './RadioButton.css';
import { ReactComponent as CheckIcon } from '../../../assets/images/ic_check.svg';

function RadioButton(props) {
    const {id, callback, selected} = props;

    const handleClick = () => {
        callback(id)
    }

    return (
        <div className={`radioButton ${selected && "radioButton--selected"}`} onClick={handleClick}>
            {selected && <CheckIcon className="radioButton__icon"/>}
        </div>
    );

}

export default RadioButton;